module.exports = __webpack_public_path__ + "static/media/saint-barthelemy.4d7d2027.svg";